export enum PDISolutionType {
  CStoreEssentialsScanDataBasic = 'CStoreEssentialsScanDataBasic',
  CStoreEssentialsStoreOperationsStandard = 'CStoreEssentialsStoreOperationsStandard',
  TopOffRewards = 'TopOffRewards',
}
